import { render, staticRenderFns } from "./cis-synonyms.vue?vue&type=template&id=73c84e73"
import script from "./cis-synonyms.vue?vue&type=script&lang=js"
export * from "./cis-synonyms.vue?vue&type=script&lang=js"
import style0 from "./cis-synonyms.vue?vue&type=style&index=0&id=73c84e73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports